import {useEffect,useState} from 'react';
import { useNavigate } from "react-router-dom";

import Typography from '@mui/material/Typography';
import Breadcrumbs from '@mui/material/Breadcrumbs';
import Link from '@mui/material/Link';
import Divider from '@mui/material/Divider';
import CircularProgress from '@mui/material/CircularProgress';


import TopPrivateNavigation from '../components/TopPrivateNavigation.jsx'
import Footer from '../components/Footer.jsx'
import AppLogout from '../components/AppLogout.jsx'

//services
import AuthService from '../service/auth'
import SettingsService from '../service/Settings'
import ProjectService from '../service/Project'


const formatJson=function(json){
    return JSON.stringify(json); 
}

const formatDate=function(d){
	var d = new Date(d);
	Number.prototype.padLeft = function(base,chr){
    var  len = (String(base || 10).length - String(this).length)+1;
    return len > 0? new Array(len).join(chr || '0')+this : this;
}
    var dformat = [
               d.getDate().padLeft(),
			   (d.getMonth()+1).padLeft(),
               d.getFullYear()].join('/') +' ' +
              [d.getHours().padLeft(),
               d.getMinutes().padLeft()].join(':');
	return dformat;
}
  
const Blank = () => {
	
	const navigate = useNavigate();
	const [globalSettings,setGlobalSettings]=useState({});//global config
	const [globalSettingsLoaded,setGlobalSettingsLoaded]=useState(false);//global config
	const [modulesEnabled,setModulesEnabled]=useState({'questionnaires':false,'recipes':false,'smart_portions':false});
	const [currentUser,setCurrentUser]=useState({});
	const [devMode,setDevMode]=useState({});
	const [projectData,setProjectData]=useState([]);
	const [projectFound,setProjectFound]=useState(false);
	
	//let params = useParams();
	let project_id =ProjectService.getCurrentProject();//params.id;
	console.log('project_id',project_id);
		
	useEffect(() => {
		let _loggedInStatus = AuthService.getUserLoggedInStatus();
		if(_loggedInStatus.loggedIn){
			
			setCurrentUser(AuthService.getCurrentUser());
			setDevMode(AuthService.isDevMode());
			SettingsService.getAllFormatted().then(function(res){
				let _globalSettings=res.data;
				setGlobalSettings(res.data);
				setGlobalSettingsLoaded(true);
				console.log(res.data);
				
				var account_type=AuthService.getCurrentUser().__t;
				console.log('account_type',account_type);
				
				if(typeof _globalSettings.modules!=="undefined"){
					
					//update local modules enabled variables
					setModulesEnabled({...modulesEnabled,
						['recipes']: _globalSettings.modules.settings.recipes.on,
					})
					
					setModulesEnabled({...modulesEnabled,
						['smart_portions']: _globalSettings.modules.settings.smart_portions.on,
					})
					
					setModulesEnabled({...modulesEnabled,
						['questionnaires']: _globalSettings.modules.settings.questionnaires.on,
					})
			
				}
				//load project if set 
				if((typeof project_id !=="undefined")&&(project_id!==null)){//project filter
					loadProjectById(project_id);
				}
				
				//load by account type
				if(account_type=='Admin'){//Admin
							
				}else if(account_type=='Master'){//Master
							
								
				}else if(account_type=='Researcher'){//Researcher
								
				}

			}).catch(function(error){
				console.log(error);
			});
			
		}else{
			navigate(_loggedInStatus.redirectUrl);
		}

	}, []);
	
	function loadProjectById(project_id){
		ProjectService.getById(project_id).then(function(res){
		setProjectData(res.data);
		console.log(res.data);
		setProjectFound(true);
		}).catch(function(error){
			console.log(error);
			setProjectFound(false);
		});
	}
	
  return(
  <>
  {globalSettingsLoaded ?
  <>
	<TopPrivateNavigation/>
	<AppLogout>
	
		{/* error no project found */}
	{(!projectFound) ?
		<>
		
		<br/>
		<Breadcrumbs aria-label="breadcrumb">
        <Link underline="hover" color="inherit" href="/">
          Home
        </Link>
		 <Typography color="text.primary">Blank</Typography>
      </Breadcrumbs>
	  
	  <br/>
	  <Divider />
		<br/>
		
		
		</>
	:<></>}
	{/* if project is found */}
	{(projectFound) ?
	<>
		<br/>
		<Breadcrumbs aria-label="breadcrumb">
        <Link underline="hover" color="inherit" href="/">
          Home
        </Link>
        <Link
          underline="hover"
          color="inherit"
          href="/projects"
        >
          Projects
        </Link>
		<Link
          underline="hover"
          color="inherit"
          href={`/project/${projectData._id}`}
        >
          {projectData.name}
        </Link>
		 <Typography color="text.primary">Blank</Typography>
      </Breadcrumbs>
	  
	  <br/>
	  <Divider />
		<br/>
		
	{devMode &&
	<>
		{formatJson(modulesEnabled)}
	</>}
	<br/>
	</>
	:<></>}
	
	{/* Admin */}
	{(currentUser.__t=='Admin') ?
	<>
	
	</>
	:<></>}
	
	{/* Master */}
	{(currentUser.__t=='Master') ?
	<>
	
	</>
	:<></>}
	
	{/* Researcher */}
	{(currentUser.__t=='Researcher') ?
	<>
	
	</>
	:<></>}
	<Footer />
	</AppLogout>
	</>:<>
 <CircularProgress />
  </>}
	</>
  ) 
  ;
};

export default Blank;